import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

function isCreatingWorkspace() {
  try {
    return JSON.parse(sessionStorage.getItem('lima_onboarding_context') || '{}')?.createNew === true;
  } catch {
    return false;
  }
}

/**
 * OnboardingRoute - Wraps onboarding pages
 * - If user has completed onboarding, redirect to /overview
 * - Otherwise, show the onboarding content
 */
export function OnboardingRoute() {
  const { profile, workspace, loading } = useAuthStore();
  const location = useLocation();

  // Still loading profile
  if (loading || !profile) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner" />
      </div>
    );
  }

  // An Awaiting payment workspace is paid for first; the rest of onboarding comes after.
  if (workspace?.state === 'awaiting_payment') {
    return location.pathname === '/onboarding/payment' ? <Outlet /> : <Navigate key={location.key} to="/onboarding/payment" replace />;
  }

  // Already completed onboarding and has a workspace - redirect to overview,
  // unless they're creating another workspace (kept in sessionStorage, so it
  // survives the profile being refetched when the tab regains focus)
  if (profile.onboarding_completed && profile.workspace_id && !isCreatingWorkspace()) {
    // Keyed on the location so it fires again if something navigates back here before it settles.
    return <Navigate key={location.key} to="/overview" replace />;
  }

  // Show onboarding content
  return <Outlet />;
}

